/**
 * Composant carte de statistiques réutilisable
 * @module pages/components/StatCard
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant carte de statistiques
 * @param {Object} props
 * @param {string|number} props.value - Valeur à afficher
 * @param {string} props.label - Label de la statistique
 * @param {string} [props.className] - Classes CSS supplémentaires
 * @returns {JSX.Element}
 */
const StatCard = ({ value, label, className = '' }) => {
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-content">
        <span className="stat-value">{value}</span>
        <span className="stat-label">{label}</span>
      </div>
    </div>
  );
};

StatCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StatCard;
